import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { StatmentDetail, ResellerTransaction } from '../../../core/models/reseller-statement.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import {AuthNoticeService} from '../../../core/auth';
import { NgxDropzoneChangeEvent, NgxDropzoneComponent } from 'ngx-dropzone';
import { debounceTime, switchMap, tap } from 'rxjs/operators';
import { CollectionService } from '../../../core/services/collection.service';
import { DebtsService } from "../../../core/e-commerce/_services/debts.service";

@Component({
	selector: 'kt-dialog-payment',
	templateUrl: './dialog-payment.component.html',
	styleUrls: ['./dialog-payment.component.scss']
})
export class DialogPaymentComponent implements OnInit {

	debtDetailForm: FormGroup;
	error: boolean = false;
	@ViewChild('dropzone') dropzone: NgxDropzoneComponent;
  isLoading: boolean;
  resellerTransactions = [];
  paymentEntities;
  paymentEntity;

  constructor(
    private _snackBar: MatSnackBar,
		private cdr: ChangeDetectorRef,
		public dialogRef: MatDialogRef<DialogPaymentComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: DialogData,
		private fb: FormBuilder,
    private authNoticeService: AuthNoticeService,
    private collectionService: CollectionService,
    private debtsService: DebtsService
	) {
	}

	ngOnInit() {
        this.debtsService.getPaymentEntities().subscribe(res => {
            this.paymentEntities = res;
        });
		this.authNoticeService.setNotice(null);
		this.initPaymentForm();
	}

	initPaymentForm() {

    this.debtDetailForm = this.fb.group({
		resellerUserName: [this.data.debtDetailData ? this.data.debtDetailData.resellerUserName : null, Validators.required],
		resellerFullName: [this.data.debtDetailData ? this.data.debtDetailData.resellerFullName : '', Validators.required],
		totalDebt: [this.data.debtDetailData ? this.data.debtDetailData.totalDebt : 0, Validators.required],
    	paymentAmount: [this.data.debtDetailData ? this.data.debtDetailData.totalDebt : 0],
    	//entity: [this.data.debtDetailData ? this.data.debtDetailData.entity : '', Validators.required],
    	comments: [""],
    });
    this.paymentEntity = this.data.debtDetailData ? this.data.debtDetailData.entity : null;
    if (this.data.debtDetailData && this.data.debtDetailData.resellerTransactions) {
      this.resellerTransactions = [...this.data.debtDetailData.resellerTransactions];
    }

	}

	savePayment() {
		const controls = this.debtDetailForm.controls;
		if (this.debtDetailForm.invalid || this.paymentEntity == null) {
			Object.keys(controls).forEach(controlName => {
					controls[controlName].markAsTouched();
				}
			);
			if (this.paymentEntity == null) {
                alert('Debe completar la entidad.');
            }
			return;
		}

		let data = this.prepareJSON(this.debtDetailForm.value);
		data.entity = this.paymentEntity;

		this.collectionService.singlePayment(data).subscribe(resp => {
			this.dialogRef.close(true);
		},
		error => {
					this._snackBar.open(error.error, 'OK', {
						duration: 5000,
					});
		});
	}

	prepareJSON(data) {
        data.resellerTransactions = this.resellerTransactions;
        return data;
    }

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	isControlHasError(controlName: string, validationType: string): boolean {
		const control = this.debtDetailForm.controls[controlName];
		if (!control) {
			return false;
		}

		const result = control.hasError(validationType) && (control.dirty || control.touched);
		return result;
	}

	selectionChangeEntity($event) {
        console.log(this.paymentEntity);
    }

}

export interface DialogData {
	debtDetailData: StatmentDetail;
}
